module.exports = __webpack_public_path__ + "static/img/pay.d9b4183.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pay.png
// module id = JIdn
// module chunks = 1